import { QueryClient } from "@tanstack/react-query";

/**
 * Single app-wide React Query client.
 *
 * Lives in its own module so non-component code (logout) can cancel and drop
 * every cached query without importing App.tsx.
 *
 * @author [Rajkumar Rathod]
 */
export const queryClient = new QueryClient();
